// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Qj-z","modalContent":"Rj-z","header":"Sj-z","close":"Tj-z"};